import React from "react"

import { sourceItemRequest } from "../../actions/source-actions"

import pageComponent from "../common/page-component-hoc"

import SourceListWidgetContainer from "./source-list/SourceListWidgetContainer"
import SourceFilterWidgetContainer from "./source-filter/SourceFilterWidgetContainer"
import Source from "./source-item/Source"

const SourceComponent = ({ isFilterActive }) => (
    <div className="widgets-container clearfix row">
        <div
            className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list"
            id="source-list"
        >
            {isFilterActive ? (
                <SourceFilterWidgetContainer />
            ) : (
                <SourceListWidgetContainer />
            )}
        </div>
        <Source />
    </div>
)

export default pageComponent("sources", sourceItemRequest)(SourceComponent)
